import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSplunkLogger } from './splunk-provider';
export const SplunkNavigationLogger = () => {
    const logger = useSplunkLogger();
    const location = useLocation();
    const previousPathRef = useRef(location.pathname);
    useEffect(() => {
        const currentPath = location.pathname;
        const previousPath = previousPathRef.current;
        if (currentPath !== previousPath) {
            logger.info('Navigation', {
                eventCategory: 'navigation',
                from: previousPath,
                to: currentPath,
            });
            previousPathRef.current = currentPath;
        }
    }, [location.pathname, logger]);
    return null;
};
